module.exports = "\n<div class=\"container\">\n    <div ng-include=\"'timeout.html'\" />\n\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/account/timeouts/timeouts.html
// module id = 33
// module chunks = 0